import React, { useEffect, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Loader2, Sparkles } from 'lucide-react';
import ConceptStudio from '../components/website-vision/ConceptStudio';
import CompleteVisionBox from '../components/website-vision/CompleteVisionBox';
import BrandKitPanel from '../components/website-vision/BrandKitPanel';

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function VisionInvitePage() {
  const { token } = useParams();
  const base = `/api/vision-invite/${token}`;
  const [v, setV] = useState(null);
  const [err, setErr] = useState('');
  const [text, setText] = useState('');

  useEffect(() => {
    axios.get(`${BACKEND}${base}`).then((r) => { setV(r.data); setText(r.data.fields?.complete_vision || ''); })
      .catch((e) => setErr(e.response?.data?.detail || 'This link is no longer valid.'));
  }, [base]);

  const update = useCallback((d) => { setV(d); setText(d.fields?.complete_vision || ''); }, []);
  const save = useCallback(async (patch) => {
    const r = await axios.patch(`${BACKEND}${base}/${v.vision_id}`, patch).catch(() => null);
    if (r) setV(r.data);
  }, [base, v]);

  if (err) return <div className="min-h-screen flex items-center justify-center text-[#475569] px-6 text-center" data-testid="invite-error">{err}</div>;
  if (!v) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="animate-spin text-[#1D4ED8]" /></div>;
  const first = (v.client_name || '').split(' ')[0];

  return (
    <div className="min-h-screen bg-[#F1F5F9]" data-testid="vision-invite-page">
      <header className="bg-[#0A0F1C] text-white">
        <div className="max-w-4xl mx-auto px-5 py-10">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#F97316] mb-2">DCA Enterprises · Website Concept Studio</div>
          <h1 className="text-4xl sm:text-5xl font-black leading-tight">{first ? `${first}, let's design your website.` : "Let's design your website."}</h1>
          <p className="mt-3 text-slate-300 max-w-2xl text-sm sm:text-base">No logo, colors or photos needed. Tell us what you love and who you want to help. We'll create names, a logo, colors, your bio, offers and a website layout built to bring you customers.</p>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-5 py-8">
        <ConceptStudio vision={v} base={base} q="" onUpdate={update} onSave={save} invite />
        <BrandKitPanel vision={v} base={base} q="" onUpdate={update} />
        <div className="h-4" />
        <div className="mt-2">
          <div className="flex items-center gap-2 mb-2 text-sm font-bold text-[#0A0F1C]"><Sparkles size={15} className="text-[#F97316]" /> Prefer to just talk? Record or type anything else about your vision</div>
          <CompleteVisionBox vision={v} base={base} q="" value={text} onChange={setText}
            onSaveText={(val) => save({ fields: { ...(v.fields || {}), complete_vision: val } })}
            onServerUpdate={update} onPrefill={null} prefilling={false} hidePrefill />
        </div>
        <p className="text-center text-xs text-[#94A3B8] mt-8">Your answers save automatically. Your strategist at DCA Enterprises will see everything you share here.</p>
      </main>
    </div>
  );
}
